<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>货源</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/pubStockList' }"> 已发布货源 </el-breadcrumb-item>
      <el-breadcrumb-item>派单司机</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="toolbar-panel">
      <div class="toolbar-item">
        <el-button type="primary" size="small" @click="search" id="auto-0">筛选</el-button>
        <el-button type="primary" @click="jumpDispatch" id="auto-1">添加司机（派单）</el-button>
      </div>
    </div>

    <div class="table-custom-box mt-10" id="auto-2">
      <el-table :data="tableData.data" border>
        <el-table-column prop="plateNumber" label="车牌号" min-width="90"> </el-table-column>
        <el-table-column prop="driverName" label="司机姓名" min-width="90"> </el-table-column>
        <el-table-column prop="driverPhone" label="手机号" min-width="90"> </el-table-column>
        <el-table-column prop="dispatchDesc" label="派单状态" min-width="90"> </el-table-column>
        <el-table-column prop="dispatchName" label="派单人" min-width="90"> </el-table-column>
        <el-table-column prop="dispatchTime" label="派单时间" min-width="90">
          <template v-slot="scope">
            {{ scope.row.dispatchTime | stamp2TextDateFull(2) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="70" align="center">
          <template v-slot="scope">
            <el-button
              v-if="scope.row.dispatchStatus === 0 && orderType != 2"
              type="text"
              class="font-size12 font-blue"
              @click="handleDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:2
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/stock.new.api';
import orderApi from '@/api/order.new.api';
export default {
  name: 'DispatchDriver',
  data: function () {
    return {
      stockCode: '',
      currentPage: 1,
      pageSize: 20,
      orderType: 1,
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created() {
    this.stockCode = this.$route.params.stockCode;
    this.search();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.axiosRequest();
    },
    currentChange(val) {
      this.currentPage = val;
      this.axiosRequest();
    },
    axiosRequest() {
      const options = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        stockCode: this.stockCode
      };
      axios.post(api.queryDispatchDriver, options).then(res => {
        this.tableData.data = res.data.dispatchDriverList || [];
        this.tableData.total = res.data.total || 0;
        this.orderType = res.data.orderType;
      });
    },
    handleDel(item) {
      this.$confirm(`司机未确认，是否确认删除`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          axios.post(orderApi.cancelOrder, { orderNumber: item.orderNumber }).then(res => {
            setTimeout(() => {
              this.search();
            }, 1000);
          });
        })
        .catch(() => {});
    },
    jumpDispatch() {
      this.$router.push({ path: `/dispatch/driver/add/${this.stockCode}` });
    }
  }
};
</script>
